import { DefaultService } from '@/services/DefaultService';

export default class DespesaFormapagtoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }


    findAll(column, order, page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/despesas/forma-pagamento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/despesas/getcombo/forma-pagamento.json?situacao=${situacao}&param=${params}`), this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    updateSituacao(formapagamento) {
        return this._http.post(`${this._env}/despesas/forma-pagamento/updatesituacao`, formapagamento, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    find(id) {
        return this._http.get(`${this._env}/despesas/forma-pagamento/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    save(form) {
        return this._http.post(`${this._env}/despesas/forma-pagamento`, form, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}